import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "modal-container-element" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "filter-block" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center items-center h-64"
}
const _hoisted_6 = {
  key: 1,
  class: "cards-container"
}
const _hoisted_7 = ["card-title", "description", "icon-src", "icon-name", "onClick"]
const _hoisted_8 = {
  slot: "title",
  class: "card-title"
}
const _hoisted_9 = ["actions"]
const _hoisted_10 = ["current-page", "total-pages", "start-item", "end-item", "total-items"]

import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import Masthead from '@shell/components/ResourceList/Masthead';

import { EPINIO_TYPES } from '../types'

import { startPolling, stopPolling } from '../utils/polling';

import CatalogServiceModal from '../components/service/CatalogServiceModal.vue';
import CatalogServiceDeleteModal from '../components/service/CatalogServiceDeleteModal.vue';
import EpinioCatalogServiceModel from '../models/catalogservices';
import { overrideTableRows } from '../utils/table-formatters';
import { debounce } from 'lodash';


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore()
const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const catalogServiceModal = ref<InstanceType<typeof CatalogServiceModal> | null>(null);
const deleteModal = ref<InstanceType<typeof CatalogServiceDeleteModal> | null>(null);

const resource: string = EPINIO_TYPES.CATALOG_SERVICE;
const paginationMeta = computed(() => store.getters['epinio/paginationMeta'](resource));
const currentPage = computed(() => store.getters['epinio/currentPaginationPage'](resource));

const searchQuery = ref<string>('');

const paginating = ref(false);

async function goToPage(page: number) {
  const meta = paginationMeta.value;

  if (meta && (page < 1 || page > meta.totalPages)) return;
  paginating.value = true;
  try {
    await store.dispatch('epinio/goToPage', { type: resource, page });
  } finally {
    paginating.value = false;
  }
}

const onSearch = debounce(async (query: string) => {
  paginating.value = true;
  try {
    await store.dispatch('epinio/search', { type: resource, query });
  } finally {
    paginating.value = false;
  }
}, 500);

watch(searchQuery, (newQuery) => {
  onSearch(newQuery);
});

const canEdit = computed(() => {
  const can = store.getters['epinio/can'];

  return can && (can('catalog_service_write') || can('catalog_service'));
});
const canDelete = canEdit;
const canCreate = canEdit;

onMounted(async () => {
  paginating.value = true;
  try {
    await store.dispatch('epinio/me');
    await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CATALOG_SERVICE });
  } finally {
    paginating.value = false;
  }

  startPolling(["namespaces", "applications", "catalogservices", "services"], store);
});

onUnmounted(() => {
  stopPolling(["namespaces", "applications", "catalogservices", "services"]);
});

const list = computed(() => {
  const catalogList = store.getters['epinio/all'](EPINIO_TYPES.CATALOG_SERVICE)

  // filter empty catalog services that are added during delete
  const filteredList = catalogList.filter((service: EpinioCatalogServiceModel) => service.meta.name !== '')

  const rowActions = (row: EpinioCatalogServiceModel) => {
    const out: any[] = [];

    if (canEdit.value) {
      out.push({
        label: 'Edit',
        enabled: true,
        action: () => catalogServiceModal.value?.openEdit(row),

      });
    }
    if (canDelete.value) {
      out.push({
        enabled: true,
        label: 'Delete',
        action: () => deleteModal.value?.openDelete(row),
      });
    }

    return out;
  };

  const overrideProps = [
    {
      prop: 'availableActions',
      value: rowActions,
      conditionFn: () => true,
    },
  ];

  const processedList = overrideTableRows(filteredList, overrideProps);

  return processedList;
})

const showDetails = (chart: any) => {
  store.$router.push(chart.detailLocation)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Masthead), {
        schema: _ctx.schema,
        resource: _unref(resource)
      }, {
        createButton: _withCtx(() => [
          (_unref(canCreate))
            ? (_openBlock(), _createElementBlock("trailhand-button", {
                key: 0,
                variant: "primary",
                size: "large",
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (catalogServiceModal.value?.openCreate()))
              }, _toDisplayString(_ctx.t('generic.create')), 33))
            : (_openBlock(), _createElementBlock("div", _hoisted_2))
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(canCreate)) + " ", 1)
        ]),
        _: 1
      }, 8, ["schema", "resource"]),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("trailhand-text-input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
          type: "search",
          class: "input-sm",
          placeholder: _ctx.t('catalog.charts.search')
        }, null, 8, _hoisted_4), [
          [_vModelText, searchQuery.value]
        ])
      ]),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (paginating.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
            _createElementVNode("trailhand-loading-spinner", null, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (service) => {
              return (_openBlock(), _createElementBlock("trailhand-card", {
                key: service.id,
                "card-title": service.meta.name,
                description: service.short_description,
                "icon-src": service.service_icon ? service.service_icon : null,
                "icon-name": service.service_icon ? null : 'database',
                clickable: "",
                onClick: ($event: any) => (showDetails(service))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h3", null, _toDisplayString(service.meta.name), 1),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  (service.availableActions.length > 0)
                    ? (_openBlock(), _createElementBlock("trailhand-action-menu", {
                        key: 0,
                        actions: service.availableActions
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_7))
            }), 128))
          ]))
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("trailhand-pagination", {
      "current-page": currentPage.value,
      "total-pages": paginationMeta.value.totalPages,
      "show-info": false,
      "start-item": (currentPage.value - 1) * paginationMeta.value.pageSize + 1,
      "end-item": Math.min(currentPage.value * paginationMeta.value.pageSize, paginationMeta.value.totalItems),
      "total-items": paginationMeta.value.totalItems,
      onPageChange: _cache[2] || (_cache[2] = (e) => goToPage(e.detail.page))
    }, null, 40, _hoisted_10),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(CatalogServiceModal, {
      ref_key: "catalogServiceModal",
      ref: catalogServiceModal
    }, null, 512),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createVNode(CatalogServiceDeleteModal, {
      ref_key: "deleteModal",
      ref: deleteModal
    }, null, 512)
  ], 64))
}
}

})